import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import {
  VictoryAxis,
  VictoryBar,
  VictoryChart,
  VictoryLegend,
  VictoryStack,
  VictoryTheme,
  VictoryTooltip,
  VictoryLine,
  VictoryZoomContainer,
  VictoryLabel,
} from 'victory';

const StackedColumnWithLine = ({
  rawData,
  filteredData,
  chartMeta,
}) => {
  const chartData = chartMeta.composeChartData(filteredData);
  const tickCount = (chartData[0] || []).length + 1;
  const tickValues = [0.25, 0.5, 0.75, 1];
  const maxima = Math.max(...chartData.reduce((acc, item) => item.map((d, i) => (acc[i] || 0) + d.y), [])) || 100;
  return (
    <VictoryChart
      height={350}
      width={650}
      padding={{
        left: 90, right: 90, bottom: 70, top: 50,
      }}
      theme={VictoryTheme.material}
      domainPadding={{ x: 30, y: 20 }}
      domain={{
        y: chartMeta.domain || [0, 1.15],
      }}
      containerComponent={(
        <VictoryZoomContainer
          zoomDomain={{
            x: [0, Math.min(tickCount, 10)],
            y: chartMeta.domain || [0, 1.15],
          }}
          allowPan={tickCount > 10}
          allowZoom={false}
        />
      )}
    >
      <VictoryLegend
        x={48}
        orientation="horizontal"
        gutter={10}
        data={_.map(chartMeta.fields, (field) => ({
          name: field.name,
          symbol: { fill: field.color, type: field.type },
        }))}
      />
      <VictoryAxis
        dependentAxis
        tickValues={tickValues}
        tickFormat={(t) => chartMeta.yTickFormat(t * maxima)}
      />
      <VictoryAxis
        dependentAxis
        orientation="right"
        tickValues={tickValues}
        tickFormat={(t) => `${t * 100} %`}
      />
      <VictoryStack
        colorScale={_.map(chartMeta.fields, 'color')}
      >
        {chartData.map((rowData, i) => (
          <VictoryBar
            labelComponent={<VictoryTooltip text={(d) => chartMeta.yTickFormat(Number.parseFloat(d.y).toFixed(2))} />}
            key={i} // eslint-disable-line
            data={rowData}
            barwidth={15}
            x={(d) => d.x + 1}
            y={(d) => d.y / maxima}
          />
        ))}
      </VictoryStack>
      <VictoryStack>
        {chartMeta.composeLineData(filteredData).map((rowLine, i) => (
          <VictoryLine
            labelComponent={<VictoryLabel renderInPortal={false} />}
            key={i} // eslint-disable-line
            data={rowLine}
            y={(d) => d.y / 100}
            style={{
              data: { stroke: '#808080' },
            }}
          />
        ))}
      </VictoryStack>
      <VictoryAxis
        tickValues={chartMeta.xTickValues(rawData)}
        tickFormat={chartMeta.xTickFormat}
        style={{
          tickLabels: { angle: -30, padding: 15 },
          grid: { display: 'none' },
        }}
      />
    </VictoryChart>
  );
};

StackedColumnWithLine.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  filteredData: PropTypes.arrayOf(PropTypes.object),
  chartMeta: PropTypes.objectOf(PropTypes.shape),
  // eslint-disable-next-line react/forbid-prop-types
  rawData: PropTypes.arrayOf(PropTypes.object),
};

export default StackedColumnWithLine;
